/* eslint-disable no-console */
import IS_DEV from './devEnv/isDev';

const log = (...props: any) => (IS_DEV ? console.log(...props) : undefined);
export const logError = (...props: any) =>
  IS_DEV ? console.error(...props) : undefined;

export default log;
